var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-2 font-weight-bold"},[_vm._v("Insurance Claim")]),_c('div',{staticClass:"cardDivider mb-2"}),_c('HsabInsuranceClaim',{attrs:{"linked-claim":_vm.linkedClaim}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }